export class InboxPanelPins {
    isMessageMenuPinned: boolean = false;
    isSidePanelPinned?: boolean = false;

    constructor(isMessageMenuPinned: boolean, isSidePanelPinned?: boolean) {
        this.isMessageMenuPinned = isMessageMenuPinned;
        this.isSidePanelPinned = isSidePanelPinned;
    }
}